<template>
    <div>
        <div class="container modal-term p-0">
            <!-- <h1 class="title-term mb-0">เงื่อนไขและข้อตกลงในการใช้งาน</h1> -->
            <div class="overflow-scroll-gradient">
                <div
                    class="overflow-scroll-gradient__scroller"
                    v-html="termsContent"
                ></div>
            </div>
        </div>

        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
//mixin
import LocaleMixin from "@/mixin/LocaleMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import ModalMixin from "@/mixin/ModalMixin.js";
//service
import BzbsPDPA from "@/core/PDPA/service/BzbsPDPA.js";

export default {
    name: "Terms",
    components: {},
    mixins: [LocaleMixin, ErrorApiMixin, ModalMixin],
    data: function() {
        return {
            termsContent: "",
            termsVersion: 0,

            modalController: null
        };
    },
    created: function() {
        this.setupTerms();

        this.modalController.setAlertModal(this.alertModal);
    },
    methods: {
        setupTerms: async function() {
            // await this.apiGetTermsVersion();
            await this.apiGetTermsContent();
        },

        apiGetTermsVersion: function() {
            return new Promise((resolve, reject) => {
                BzbsPDPA.apiGetPDPAVersion().subscribe(
                    data => {
                        this.termsVersion = data.terms.current_version;
                        console.log("this.termsVersion", this.termsVersion);
                        resolve(data);
                    },
                    err => {
                        this.errorResponse(err);
                        reject(err);
                    }
                );
            });
        },
        apiGetTermsContent: function() {
            return new Promise((resolve, reject) => {
                let path = "/nestle/nescafe_streetcafe/config.json";
                BzbsPDPA.apiGetBlob(path).then(
                    data => {
                        this.termsContent = data.data[0].pdpa[0].terms;
                        resolve(data);
                    },
                    err => {
                        this.errorResponse(err);
                        reject(err);
                    }
                );
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/_mixin.scss";
.overflow-scroll-gradient {
    position: relative;
}
// .overflow-scroll-gradient::before {
//     content: "";
//     position: absolute;
//     top: 0;
//     width: -webkit-fill-available;
//     height: 25px;
//     background: linear-gradient(
//         white,
//         rgba(255, 255, 255, 0.001)
//     ); /* transparent keyword is broken in Safari */
// }
// .overflow-scroll-gradient::after {
//     content: "";
//     position: absolute;
//     bottom: 0;
//     width: -webkit-fill-available;
//     height: 25px;
//     background: linear-gradient(
//         rgba(255, 255, 255, 0.001),
//         white
//     ); /* transparent keyword is broken in Safari */
// }
.overflow-scroll-gradient__scroller {
    overflow-y: scroll;
    height: 700px;
    @include breakpoint-max(385) {
        height: 500px;
    }
    padding: 15px 0;
    line-height: 24px;
    text-align: left;
    color: white;
    font-size: 16px;
    padding-right: 10px;
}
</style>
